import { server_connection } from 'config';
import { DELETE_UNSCHEDULED_LESSON } from './course.builder.actions';
import { getContentLabelList } from '../../../content_label/store/actions';
import { initializeFilters } from '../../../../components/tableFilter/store/actions';
import history from 'history.js';
// This causes the app to crash
// import store from 'store';

export const GET_COURSE = '[COURSE APP] GET COURSE';
export const GET_COURSE_LIST = '[COURSE APP] GET COURSE LIST';
export const DELETE_COURSE = '[COURSE APP] DELETE COURSE';
export const UPDATE_COURSE_LOADED = '[COURSE APP] UPDATE COURSE LOADED';
export const UPDATE_COURSE_LIST_LOADED = '[COURSE APP] UPDATE COURSE LIST LOADED';
export const GET_COURSE_DATA = '[COURSE APP] GET COURSE DATA';
export const UPDATE_COURSE_FORM = '[COURSE APP] UPDATE COURSE FORM';
export const GET_RELATED_DATA = '[COURSE APP] GET RELATED DATA';
export const GET_COURSE_ASSET_LIST = '[COURSE APP] GET COURSE ASSET LIST';
export const GET_ALL_QUALIFICATIONS = '[COURSE APP] GET ALL QUALIFICATIONS';
export const UPDATE_COURSE_QUALIFICATION_FORM = '[COURSE APP] UPDATE COURSE QUALIFICATION FORM';
export const UPDATE_COURSE_INTRO = '[COURSE APP] UPDATE COURSE INTRO';
export const CLEAR_SCHEDULE = '[COURSE APP] CLEAR SCHEDULE';
export const PUSH_UNSCHEDULED_LESSON_OUTSIDE_BUILDER = '[COURSE APP] PUSH UNSCHEDULED LESSON OUTSIDE BUILDER';
export const MOVE_UNSCHEDULED_LESSON_OUTSIDE_BUILDER = '[COURSE APP] MOVE UNSCHEDULED LESSON OUTSIDE BUILDER';
export const DELETE_UNSCHEDULED_LESSON_OUTSIDE_BUILDER = '[COURSE APP] DELETE UNSCHEDULED LESSON OUTSIDE BUILDER';
export const LOCK_COURSE = '[COURSE APP] LOCK COURSE';
export const UNLOCK_COURSE = '[COURSE APP] UNLOCK COURSE';
export const GET_APP_QUALIFICATION_DATA = '[COURSE APP] GET APP QUALIFICATION DATA';
export const ACTIVATE_COURSE = '[COURSE APP] ACTIVATE COURSE';

// COURSE -> Major relations
export const GET_ALL_MAJORS = '[COURSE APP] GET ALL MAJORS';
export const TOGGLE_MAJOR = '[COURSE APP] TOGGLE MAJOR';

// COURSE -> Instructor relations
export const GET_ALL_INSTRUCTORS = '[COURSE APP] GET ALL INSTRUCTORS';
export const TOGGLE_INSTRUCTOR = '[COURSE APP] TOGGLE INSTRUCTOR';

// COURSE -> Module relations
export const GET_ALL_MODULES = '[COURSE APP] GET ALL MODULES';
export const TOGGLE_MODULE = '[COURSE APP] TOGGLE MODULE';

// COURSE -> Prerequisite relations
export const GET_CURRENT_COURSE_PREREQUISITE_LIST = '[COURSE APP] GET CURRENT COURSE PREREQUISITE LIST';
export const TOGGLE_PREREQUISITE_COURSE = '[COURSE APP] TOGGLE PREREQUISITE COURSE';
export const PREREQUISITE_UPDATE_SEARCH = '[COURSE APP] PREREQUISITE UPDATE SEARCH';
export const GET_POTENTIAL_COURSE_PREREQUISITES = '[COURSE APP] GET POTENTIAL COURSE PREREQUISITES';

export const TOGGLE_COMPANY = '[COURSE APP] TOGGLE COMPANY';
export const COMPANY_UPDATE_SEARCH = '[COURSE APP] COMPANY UPDATE SEARCH';

export const GET_ALL_LESSONS = '[COURSE APP] GET ALL LESSONS';
export const UPDATE_ASSET_NAME = '[COURSE APP] UPDATE ASSET NAME';

export const TOGGLE_COURSE_REPULL = '[COURSE APP] TOGGLE COURSE REPULL';
export const UPDATE_NEW_COURSE_NAME = '[COURSE APP] UPDATE NEW COURSE NAME';

export function updateCourseLoaded(setting) {
    return {
        type: UPDATE_COURSE_LOADED,
        payload: setting
    }
}

export function updateCourseListLoaded(setting) {
    return {
        type: UPDATE_COURSE_LIST_LOADED,
        payload: setting
    }
}

export function updateCourseForm(course_data) {
    return {
        type: UPDATE_COURSE_FORM,
        payload: course_data
    }
}

export function updateCourseQualificationForm(course_data) {
    return {
        type: UPDATE_COURSE_QUALIFICATION_FORM,
        payload: course_data
    }
}

// Not used. For if we want to handle intro courses at this level
export function updateCourseIntro(data) {
    return {
        type: UPDATE_COURSE_INTRO,
        payload: data
    }
}

export function getCourse(course_id) {
    return (dispatch, getState) => {
        return fetch(server_connection + '/course/get/' + course_id)
            .then((response) => response.json())
            .then((courseData) => {
                return dispatch({
                    type: GET_COURSE,
                    payload: courseData,
                });
            });
    }
}

export function getCourseAssetList(course_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/course/asset_list/' + course_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_COURSE_ASSET_LIST,
                    payload: responseData,
                });
            });
    }
}

export function saveCourse(course, mappedLessons, currentCoursePrerequisiteList, auth_id, companies) {
    const create_id = course.course_id === 0 ? auth_id : course.CreateAuthID;
    const newCourse = {
        ...course,
        CreateAuthID: create_id,
        LastEditAuthID: auth_id
    }
    return async (dispatch, getState) => {
        await fetch(server_connection + '/course/save',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    course: newCourse,
                    mappedLessons: mappedLessons,
                    currentCoursePrerequisiteList: currentCoursePrerequisiteList,
                    companies
                })
            })
            .then((response) => response.json())

            .then((responseData) => {
                dispatch(getCourseList(auth_id, 'actions'));
            })

    }
}

export function deleteCourse(course_id, auth_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/course/delete',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ course_id: course_id, auth_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: DELETE_COURSE,
                    payload: course_id,
                });
            });
    }
}

export function getCourseList(auth_id, call_location) {
    // calling store crashes the app
    // let auth_id = store.getState();
    return (dispatch, getState) => {
        fetch(server_connection + '/course/list/' + auth_id)
            .then((response) => response.json())
            .then((courseList) => {
                dispatch({
                    type: GET_COURSE_LIST,
                    payload: { courseList, call_location }
                });
            });
    }
}

export function getAllMajors(auth_id) {
    return (dispatch) => {
        return fetch(server_connection + '/major/list/' + auth_id)
            .then((response) => response.json())
            .then((allMajors) => {
                return dispatch({
                    type: GET_ALL_MAJORS,
                    payload: allMajors
                })
            })
    }
}

export function toggleMajor(major, action_type) {
    return {
        type: TOGGLE_MAJOR,
        payload: { major: major, action_type: action_type }
    }
}

export function getAllInstructors() {
    return (dispatch) => {
        return fetch(server_connection + '/instructor/list')
            .then((response) => response.json())
            .then((allInstructors) => {
                return dispatch({
                    type: GET_ALL_INSTRUCTORS,
                    payload: allInstructors
                })
            })
    }
}

export function getAllLessons(auth_id) {
    return (dispatch) => {
        return fetch(server_connection + '/lesson/list/' + auth_id)
            .then((response) => response.json())
            .then((allLessons) => {
                return dispatch({
                    type: GET_ALL_LESSONS,
                    payload: allLessons
                })
            })
    }
}

export function toggleInstructor(instructor, action_type) {
    return {
        type: TOGGLE_INSTRUCTOR,
        payload: { instructor: instructor, action_type: action_type }
    }
}

export function getAllModules(auth_id) {
    return (dispatch) => {
        return fetch(server_connection + '/module/list/' + auth_id)
            .then((response) => response.json())
            .then((allModules) => {
                return dispatch({
                    type: GET_ALL_MODULES,
                    payload: allModules
                })
            })
    }
}

export function toggleModule(module, action_type) {
    return {
        type: TOGGLE_MODULE,
        payload: { module: module, action_type: action_type }
    }
}

export function getRelatedData(course_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/course/data/' + course_id)
            .then((response) => response.json())
            .then((relatedData) => {
                dispatch({
                    type: GET_RELATED_DATA,
                    payload: relatedData
                })
            })
    }
}

//
//  Actions for handling Course Prerequisites
//

export function getCoursePrerequisiteList(course_id) {
    return (dispatch) => {
        return fetch(server_connection + '/course/prerequisites/list/' + course_id)
            .then((response) => response.json())
            .then(currentCoursePrerequisiteList =>
                dispatch({
                    type: GET_CURRENT_COURSE_PREREQUISITE_LIST,
                    payload: currentCoursePrerequisiteList
                })
            );
    };
};

export function getPotentialCoursePrerequisites(course_id, auth_id) {
    return (dispatch) => {
        fetch(server_connection + '/course/prerequisites/potential/' + course_id + '/' + auth_id)
            .then((response) => response.json())
            .then((potentialCoursePrerequisites) => {
                dispatch({
                    type: GET_POTENTIAL_COURSE_PREREQUISITES,
                    payload: potentialCoursePrerequisites
                })
            })
    }
}

export function prerequisiteUpdateSearch(characters) {
    return {
        type: PREREQUISITE_UPDATE_SEARCH,
        payload: characters
    }
}

export function companyUpdateSearch(characters) {
    return {
        type: COMPANY_UPDATE_SEARCH,
        payload: characters
    }
}

export function togglePrerequisiteCourse(prerequisiteCourse, action_type) {
    return {
        type: TOGGLE_PREREQUISITE_COURSE,
        payload: { prerequisiteCourse: prerequisiteCourse, action_type: action_type }
    }
}

export function toggleCompany(company, action_type) {
    return {
        type: TOGGLE_COMPANY,
        payload: { company, action_type }
    }
}


export function getAllQualifications(auth_id) {
    return (dispatch, getState) => {
        return fetch(server_connection + '/qualification/list/' + auth_id)
            .then((response) => response.json())
            .then((responseData) => {
                return dispatch({
                    type: GET_ALL_QUALIFICATIONS,
                    payload: responseData
                });
            });
    }
}

export function getAppQualificationData() {
    return (dispatch, getState) => {
        return fetch(server_connection + '/qualification/apps')
            .then((response) => response.json())
            .then((responseData) => {
                return dispatch({
                    type: GET_APP_QUALIFICATION_DATA,
                    payload: responseData
                });
            });
    }
}

export function clearSchedule() {
    return {
        type: CLEAR_SCHEDULE,
        payload: true
    }
}

export function pushUnscheduledLessonOutsideBuilder(lesson) {
    return {
        type: PUSH_UNSCHEDULED_LESSON_OUTSIDE_BUILDER,
        payload: { lesson }
    }
}

export function moveUnscheduledLessonOutsideBuilder(dragIndex, hoverIndex, event) {
    return {
        type: MOVE_UNSCHEDULED_LESSON_OUTSIDE_BUILDER,
        payload: { dragIndex, hoverIndex, event }
    }
}

export function deleteUnscheduledLessonOutsideBuilder(lesson) {
    return {
        type: DELETE_UNSCHEDULED_LESSON_OUTSIDE_BUILDER,
        payload: lesson
    }
}

export function lockCourse(course_id, auth_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/course/lock',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ course_id, auth_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: LOCK_COURSE,
                    payload: auth_id
                });
            });
    }
}

export function unlockCourse(course_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/course/unlock',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ course_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: UNLOCK_COURSE,
                    payload: true,
                });
            });
    }
}

export function activateCourse(course_id, auth_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/course/activate',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ course_id, auth_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: ACTIVATE_COURSE,
                    payload: true,
                });
            });
    }
}

export function updateAssetName(newName, asset_id, saved) {
    return {
        type: UPDATE_ASSET_NAME,
        payload: {newName, asset_id, saved}
    }
}

export function getCourseData(course_id, auth_id) {
    return (dispatch) => {
        Promise.all([
            dispatch(getCourse(course_id)),
            dispatch(getCoursePrerequisiteList(course_id)),
            dispatch(getPotentialCoursePrerequisites(course_id, auth_id)),
            dispatch(getAllMajors(auth_id)),
            dispatch(getAllInstructors()),
            dispatch(getAllModules(auth_id)),
            dispatch(getAllLessons(auth_id)),
            dispatch(getRelatedData(course_id)),
            dispatch(getCourseAssetList(course_id)),
            dispatch(getAllQualifications(auth_id)),
            dispatch(getContentLabelList())
        ]).then(
            () => dispatch(updateCourseLoaded(true))
        )
    }
}

export function updateNewCourseName(data) {
    return {
        type: UPDATE_NEW_COURSE_NAME,
        payload: data
    }
}

export function toggleCourseRepull(setting) {
    return {
        type: TOGGLE_COURSE_REPULL,
        payload: setting
    }
}

export function saveCourseCopy(course, mappedLessons, currentCoursePrerequisiteList, auth_id, companies) {
    const create_id = course.course_id === 0 ? auth_id : course.CreateAuthID;
    const newCourse = {
        ...course,
        CreateAuthID: create_id,
        LastEditAuthID: auth_id
    }
    return async (dispatch, getState) => {
        await fetch(server_connection + '/course/save_copy',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    course: newCourse,
                    mappedLessons,
                    currentCoursePrerequisiteList,
                    companies
                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                console.log(responseData)
                Promise.all([
                    dispatch(getCourseList(auth_id, 'actions')),
                    dispatch({
                        type: TOGGLE_COURSE_REPULL,
                        payload: true,
                    }),
                    history.push({
                        pathname: '/course/edit/' + responseData.result
                    })
                ])
            });
    }
}


// WEBPACK FOOTER //
// src/main/content/course/store/actions/course.actions.js